import { useEffect, useRef, useState } from "react";

export const StatCounter = ({ value = 0, suffix = "+", label, duration = 1800 }) => {
  const [n, setN] = useState(0);
  const started = useRef(false);
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const start = performance.now();
          const tick = (t) => {
            const p = Math.min((t - start) / duration, 1);
            const eased = 1 - Math.pow(1 - p, 3);
            setN(Math.round(value * eased));
            if (p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }
      },
      { threshold: 0.4 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [value, duration]);

  return (
    <div ref={ref} data-testid={`stat-${label?.toLowerCase().replace(/\s+/g, "-")}`}>
      <p className="font-display text-5xl md:text-6xl lg:text-7xl font-light tracking-tight">
        {n}
        <span className="text-gold">{suffix}</span>
      </p>
      <p className="mt-3 text-xs uppercase tracking-[0.24em] text-muted-foreground">{label}</p>
    </div>
  );
};
